import { Component, OnInit, Inject, Input, ViewChild, ElementRef, Renderer2, AfterViewInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { FormGroup, FormBuilder } from "@angular/forms";
import { Router } from '@angular/router';
import { ServicesService } from '../../../../../../services/services.service';
import { ServicesLogosService } from '../../../../../../../core/services/services-logos.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthorizationSchemeService } from 'src/app/contexts/snapshot/authorization_scheme.service';



@Component({
    selector: 'app-flow-authorization-scheme-modal',
    templateUrl: './flow-authorization-scheme-modal.component.html',
    styleUrls: ['./flow-authorization-scheme-modal.component.scss', './flow-authorization-scheme-modal-responsive.component.scss']
})
export class FlowAuthorizationSchemeModalComponent implements OnInit, AfterViewInit {

    model: any = {};
    @ViewChild('allocationField') allocationField: ElementRef<HTMLInputElement>;
    @ViewChild('content') contentElement: ElementRef;
    @ViewChild('header') headerElement: ElementRef;
    @ViewChild('footer') footerElement: ElementRef;
    @ViewChild('edit') editElement: ElementRef;
    @ViewChild('name') nameElement: ElementRef;
    @Input() is_default: any;

    isScrolled: boolean = false;
    formBuilder: FormBuilder;
    formRange: FormGroup;
    invalid = true;
    creatingOrEditing = 'creating';
    canShowErrorSum = false;

    max = 100;
    min = 0;
    showTicks = false;
    step = 1;
    thumbLabel = false;
    value = 0;

    constructor(
        private dialogRef: MatDialogRef<FlowAuthorizationSchemeModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private changeDetectorRef: ChangeDetectorRef,
        private toastr: ToastrService,
        private servicesService: ServicesService,
        private authorizationSchemeService: AuthorizationSchemeService,
        private ServicesLogosService: ServicesLogosService,
        private translate: TranslateService,
        private router: Router) { }

    ngOnInit() {
        this.model.services = [];
        this.model.open = true;
        this.model.partner = this.data.partner;
        this.model.account = this.data.account;
        this.model.authorization_scheme = this.data.authorization_scheme;
        this.model.services = this.data.services;

        //this.model.services.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
        this.images();

        if (this.model.authorization_scheme.id)
            this.creatingOrEditing = 'editing';

        console.log(this.creatingOrEditing);

        this.model.authorization_scheme.steps.forEach(element => {
            element.id = this.uuidv4();
            if (this.creatingOrEditing == 'editing') {

                element.first_service_id = element.first_service?.id;
                element.first_version_id = element.first_service?.version ? element.first_service.version : 0;
                element.second_service_id = element.second_service?.id ? element.second_service.id : null;
                element.second_version_id = element.second_service?.version ? element.second_service.version : 0;
                element.third_service_id = element.third_service?.id ? element.third_service.id : null;
                element.third_version_id = element.third_service?.version ? element.third_service.version : 0;


                //not show in list when exists
                if (element.first_service?.id) {
                    element.first_service.services.find(p => p.service_id == element.first_service.id && p.version_id == element.first_service.version).addFirst = true;

                    element.second_service.services = element.second_service?.services.filter(p => !(p.service_id == element.first_service.id && p.version_id == element.first_service.version));
                    element.third_service.services = element.third_service?.services.filter(p => !(p.service_id == element.first_service.id && p.version_id == element.first_service.version));
                }
                if (element.second_service?.id) {
                    element.second_service.services.find(p => p.service_id == element.second_service.id && p.version_id == element.second_service.version).addSecond = true;

                    element.first_service.services = element.first_service?.services.filter(p => !(p.service_id == element.second_service.id && p.version_id == element.second_service.version));
                    element.third_service.services = element.third_service?.services.filter(p => !(p.service_id == element.second_service.id && p.version_id == element.second_service.version));
                }
                if (element.third_service?.id) {
                    element.third_service.services.find(p => p.service_id == element.third_service.id && p.version_id == element.third_service.version).addThird = true;

                    element.first_service.services = element.first_service?.services.filter(p => !(p.service_id == element.third_service.id && p.version_id == element.third_service.version));
                    element.second_service.services = element.second_service?.services.filter(p => !(p.service_id == element.third_service.id && p.version_id == element.third_service.version));
                }


            }
        });

        this.valid();
    }

    list() {
        this.servicesService.filter(this.model.partner, this.model.account, ['G'], true).subscribe(response => {
            this.model.services = response.services.filter(p => p.active);
            this.images();
        });

    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    images() {
        if (this.model.services.length > 0) {
            this.model.services.forEach(async element => {
                element.image_path = await this.ServicesLogosService.getLogo(element);
            });
        }
        if (this.model.authorization_scheme)
            this.model.authorization_scheme.steps.forEach(async step => {
                step.id = this.uuidv4();
                if (step) {
                    if (step.first_service) {
                        if (step.first_service.name) {
                            step.first_service.image_path = await this.ServicesLogosService.getLogo(step.first_service);
                            var service = this.model.services.find(p => p.service_name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") == step.first_service.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
                            if (service)
                                service.addFirst = true;
                        }
                    }
                    if (step.second_service) {
                        if (step.second_service.name) {
                            step.second_service.image_path = await this.ServicesLogosService.getLogo(step.second_service);
                            var service = this.model.services.find(p => p.service_name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") == step.second_service.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
                            if (service)
                                service.addSecond = true;
                        }
                    }
                    if (step.third_service) {
                        if (step.third_service.name) {
                            step.third_service.image_path = await this.ServicesLogosService.getLogo(step.third_service);
                            var service = this.model.services.find(p => p.service_name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") == step.third_service.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
                            if (service)
                                service.addThird = true;
                        }
                    }
                }
            });

    }

    updateUrl(service) {
        service.image_path = null;
    }

    close() {
        this.dialogRef.close();
    }

    onContentScroll(event) {
        if (event.srcElement.scrollTop > 0) {
            this.isScrolled = true;
        } else {
            this.isScrolled = false;
        }
    }

    ngAfterViewInit() {
        this.changeDetectorRef.detectChanges();
    }

    goToService() {
        this.dialogRef.close();
        this.router.navigate([this.model.partner, this.model.account, 'services']);
    }

    addServiceFirst(step, service, index) {

        this.removeDeleteServiceFirst(step);

        step.first_service.id = service.service_id;
        step.first_service.version = service.version_id;
        step.first_service.name = service.service_name;
        step.first_service.custom_name = service.custom_name;
        step.first_service.image_path = service.image_path;
        service.addFirst = true;
        if (index == 0)
            step.percentage = 100;

        step.first_service.services.sort((a, b) => a.addFirst - b.addFirst);
        step.second_service.services = step.second_service?.services.filter(p => !(p.service_id == service.service_id && p.version_id == service.version_id));
        step.third_service.services = step.third_service?.services.filter(p => !(p.service_id == service.service_id && p.version_id == service.version_id));

        this.valid();
    }

    removeServiceFirst(step) {


        const myClonedArray = [];
        this.model.services.forEach(val => myClonedArray.push(Object.assign({}, val)));

        step.first_service = {
            services: myClonedArray
        };
        step.percentage = 0;

        this.removeDeleteServiceFirst(step);

        this.valid();

    }

    removeDeleteServiceFirst(step) {
        step.first_service.services.forEach(element => {
            element.addFirst = false;
        });
    }

    addServiceSecond(step, service) {

        this.removeDeleteServiceSecond(step);

        step.second_service.id = service.service_id;
        step.second_service.version = service.version_id;
        step.second_service.name = service.service_name;
        step.second_service.custom_name = service.custom_name;
        step.second_service.image_path = service.image_path;
        service.addSecond = true;

        step.second_service.services.sort((a, b) => a.addFirst - b.addFirst);

        step.first_service.services = step.first_service.services.filter(p => !(p.service_id == service.service_id && p.version_id == service.version_id));
        step.third_service.services = step.third_service.services.filter(p => !(p.service_id == service.service_id && p.version_id == service.version_id));

        this.valid();
    }

    removeServiceSecond(step) {

        const myClonedArray = [];
        this.model.services.forEach(val => myClonedArray.push(Object.assign({}, val)));

        step.second_service = {
            services: myClonedArray
        };
        step.percentage = 0;

        this.removeDeleteServiceSecond(step);

        this.valid();

    }

    removeDeleteServiceSecond(step) {
        step.second_service.services.forEach(element => {
            element.addSecond = false;
        });
    }

    addServiceThird(step, service) {

        this.removeDeleteServiceThird(step);

        step.third_service.id = service.service_id;
        step.third_service.version = service.version_id;
        step.third_service.name = service.service_name;
        step.third_service.custom_name = service.custom_name;
        step.third_service.image_path = service.image_path;
        service.addThird = true;

        step.third_service.services.sort((a, b) => a.addFirst - b.addFirst);

        step.first_service.services = step.first_service.services.filter(p => !(p.service_id == service.service_id && p.version_id == service.version_id));
        step.second_service.services = step.second_service?.services.filter(p => !(p.service_id == service.service_id && p.version_id == service.version_id));

        this.valid();

    }

    removeServiceThird(step) {
        step.third_service.services.find(p => p.service_id == step.third_service?.id && p.version_id == step.third_service.version).addThird = false;
        const myClonedArray = [];
        this.model.services.forEach(val => myClonedArray.push(Object.assign({}, val)));

        step.third_service = {
            services: myClonedArray
        };
        this.valid();

    }

    removeDeleteServiceThird(step) {
        step.third_service.services.forEach(element => {
            element.addThird = false;
        });
    }

    editStep(event: any) {
        event.stopPropagation();
    }

    addRow() {
        const myClonedArray = [];
        this.model.services.forEach(val => myClonedArray.push(Object.assign({}, val)));

        const myClonedArray2 = [];
        this.model.services.forEach(val => myClonedArray2.push(Object.assign({}, val)));

        const myClonedArray3 = [];
        this.model.services.forEach(val => myClonedArray3.push(Object.assign({}, val)));


        this.model.authorization_scheme.steps.push({
            id: this.uuidv4(),
            first_service: {
                services: myClonedArray
            },
            second_service: {
                services: myClonedArray2
            },
            third_service: {
                services: myClonedArray3
            },
            percentage: 0
        });

        this.valid();
    }

    // hasDuplicates(arr) {
    //     return new Set(arr.map(JSON.stringify)).size !== arr.length;
    // }

    valid() {

        this.invalid = true;

        let sum = this.model.authorization_scheme.steps.map(p => parseInt(p.percentage)).reduce((a, b) => a + b, 0);
        if (sum != 0 && (sum > 100 || sum < 100))
            this.canShowErrorSum = true;
        else
            this.canShowErrorSum = false;

        let testStep = 0;
        // this.model.authorization_scheme.steps.forEach(step => {
        //     if (!step.first_service.id)
        //         testStep++;
        //     if (step.first_service.id && !step.second_service.id && step.third_service.id)
        //         testStep++;
        //     if (step.first_service)
        //         if (step.first_service.services)
        //             if (step.first_service.services.find(p => p.addFirst))
        //                 if (step.first_service.services.find(p => p.addFirst) == step.first_service.services.find(p => p.addSecond))
        //                     testStep++;
        //     if (step.second_service)
        //         if (step.second_service.services)
        //             if (step.second_service.services.find(p => p.addSecond))
        //                 if (step.second_service.services.find(p => p.addSecond) == step.second_service.services.find(p => p.addThird))
        //                     testStep++;
        //     if (step.third_service)
        //         if (step.third_service.services)
        //             if (step.third_service.services.find(p => p.addFirst))
        //                 if (step.third_service.services.find(p => p.addFirst) == step.third_service.services.find(p => p.addThird))
        //                     testStep++;
        // });

        // var duplicates = this.model.authorization_scheme.steps.map((item) => {
        //     if (item.first_service) {
        //         return {
        //             first_service: { id: item.first_service ? item.first_service.id : null, version: item.first_service ? item.first_service.version : null },
        //             second_service: { id: item.second_service ? item.second_service.id : null, version: item.second_service ? item.second_service.version : null },
        //             third_service: { id: item.third_service ? item.third_service.id : null, version: item.third_service ? item.third_service.version : null }
        //         }
        //     } else {
        //         return null;
        //     }
        // });

        // const isDuplicate = this.hasDuplicates(duplicates);

        // if (isDuplicate)
        //     testStep++;

        if ((!(this.model.authorization_scheme.steps.some(p => parseInt(p.percentage) == 0))) //se não tem algum step vazio
            && (sum == 100) //se soma é 100
            && (!(sum > 100))
            && (testStep == 0))  //se soma não é maior que 100)
            this.invalid = false;

    }

    save() {

        var steps = [];
        this.model.authorization_scheme.steps.forEach(element => {
            steps.push({
                first_service_id: element.first_service.id,
                first_version_id: element.first_service.version ? element.first_service.version : 0,
                second_service_id: element.second_service ? element.second_service.id : null,
                second_version_id: element.second_service ? element.second_service.version : null,
                third_service_id: element.third_service ? element.third_service.id : null,
                third_version_id: element.third_service ? element.third_service.version : null,
                percentage: element.percentage
            })
        });
        if (this.creatingOrEditing == 'creating') {
            var create = {
                name: this.model.authorization_scheme.name,
                steps: steps
            };
            this.authorizationSchemeService.create(this.model.partner, this.model.account, create).subscribe(response => {
                this.toastr.success(this.translate.instant('flows.modal.authorization_scheme.success.start')
                    + ' "' + this.model.authorization_scheme.name + '" ' +
                    this.translate.instant('flows.modal.authorization_scheme.success.create'));
                this.dialogRef.close({ response, createOrEditing: 'creating' });
            });
        } else {

            var edit = {
                id: this.model.authorization_scheme.id,
                name: this.model.authorization_scheme.name,
                steps: steps
            };
            this.authorizationSchemeService.edit(this.model.partner, this.model.account, edit).subscribe(response => {
                this.toastr.success(this.translate.instant('flows.modal.authorization_scheme.success.start')
                    + ' "' + this.model.authorization_scheme.name + '" ' +
                    this.translate.instant('flows.modal.authorization_scheme.success.save'));
                this.dialogRef.close({ response, createOrEditing: 'editing' });
            });
        }
    }

    removeRow(as) {
        const index = this.model.authorization_scheme.steps.indexOf(as, 0);
        if (index > -1) {
            this.model.authorization_scheme.steps.splice(index, 1);
        }
        if (this.model.authorization_scheme.steps.length == 1)
            this.model.authorization_scheme.steps[0].percentage = 100;

        this.removeDeleteServiceFirst(this.model.authorization_scheme.steps[index]);
        this.removeDeleteServiceSecond(this.model.authorization_scheme.steps[index]);
        this.removeDeleteServiceThird(this.model.authorization_scheme.steps[index]);
        this.valid();
    }

    addFlow() {
        this.dialogRef.close(this.model.authorization_scheme);
    }

    clickEditName() {
        setTimeout(() => {
            this.editElement.nativeElement.select();
        }, 100);
    }

    inputNameKeyupEnter(event) {
        this.editStep(event);
        this.nameElement.nativeElement.hidden = false;
    }

    formatPartnerClass(string) {
        return string.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
}

